import DV360TicketsLineItemFormBasicInfo from './BasicInfo';
import DV360TicketsProductSection from './ProductSection';

const components = [DV360TicketsLineItemFormBasicInfo, DV360TicketsProductSection];

interface IProps {
  index: number;
}

const DV360LineItemFormBasicSection = (props: IProps) => {
  return components.map((Component, index) => <Component key={index} {...props} />);
};

export default DV360LineItemFormBasicSection;
